import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";

import {
  getFirebaseApiKey,
  getFirebaseAppID,
  getFirebaseAuthDomain,
  getFirebaseMessagingSenderId,
  getFirebaseProjectId,
  getFirebaseStorageBucket,
} from "./utils/config-utils";

const firebaseConfig = {
  apiKey: getFirebaseApiKey(),
  authDomain: getFirebaseAuthDomain(),
  projectId: getFirebaseProjectId(),
  storageBucket: getFirebaseStorageBucket(),
  messagingSenderId: getFirebaseMessagingSenderId(),
  appId: getFirebaseAppID(),
};

const app = initializeApp(firebaseConfig);
const storage = getStorage(app);

export { storage };
